import { SyntheticEvent, useState } from "react";
import { Slider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { LayerProperties } from "types";

interface Props {
  config: string;
  value: number;
  layerProperties: LayerProperties[];
  className: string;
  onChange: (value: number) => void;
}

export function OpacitySlider(props: Props) {
  const { t } = useTranslation();
  const [controlledValue, setControlledValue] = useState(props.value * 100);

  function handleChange(event: Event, value: number | number[]) {
    if (!Array.isArray(value)) setControlledValue(value);
    else if (Array.isArray(value)) setControlledValue(value.shift() || 100);
  }

  function handleChangeCommitted(
    event: SyntheticEvent<Element, Event> | Event,
    value: number | number[]
  ) {
    if (!Array.isArray(value)) props.onChange(value / 100);
    else props.onChange(value[0] / 100);
  }

  return render();

  function render() {
    return (
      <div className={props.className}>
        <Typography
          component="label"
          variant="subtitle2"
          fontSize="small"
          className="label"
        >
          {t("label.transparancy")}
        </Typography>

        <Slider
          min={0}
          max={100}
          step={1}
          size="small"
          value={controlledValue}
          onChange={handleChange}
          onChangeCommitted={handleChangeCommitted}
        />
      </div>
    );
  }
}
